import { render, staticRenderFns } from "./commonSelect.vue?vue&type=template&id=c8834b5e&scoped=true&"
import script from "./commonSelect.vue?vue&type=script&lang=js&"
export * from "./commonSelect.vue?vue&type=script&lang=js&"
import style0 from "./commonSelect.vue?vue&type=style&index=0&id=c8834b5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8834b5e",
  null
  
)

export default component.exports